import type { BuildingContext } from '@quipex/shared/contracts';
import type {
    QuippyBuildingSession,
    QuippyScope,
    QuippyThread,
} from '../models';
import { findThread, getSidebarThreads } from './helpers';
import { fromQuippySessionKey } from './scope';

export interface StoredConversation {
    scope: QuippyScope;
    thread: QuippyThread;
    buildingContext?: BuildingContext;
}

export function readConversation(
    sessions: ReadonlyMap<string, QuippyBuildingSession>,
    chatId: string
): (StoredConversation & { draft: string }) | null {
    for (const [key, session] of sessions) {
        const thread = findThread(session, chatId);
        if (!thread) continue;
        return {
            scope: fromQuippySessionKey(key),
            thread,
            draft: session.draftByChat[chatId] ?? '',
            buildingContext: session.buildingContext,
        };
    }
    return null;
}

export function listConversations(
    sessions: ReadonlyMap<string, QuippyBuildingSession>
): StoredConversation[] {
    const rows: StoredConversation[] = [];
    for (const [key, session] of sessions) {
        const scope = fromQuippySessionKey(key);
        for (const thread of getSidebarThreads(session)) {
            rows.push({
                scope,
                thread,
                buildingContext: session.buildingContext,
            });
        }
    }
    return rows.sort(
        (a, b) => b.thread.timestamp.getTime() - a.thread.timestamp.getTime()
    );
}

export function removeConversation(
    session: QuippyBuildingSession,
    chatId: string
): QuippyBuildingSession {
    const draftByChat = { ...session.draftByChat };
    delete draftByChat[chatId];
    return {
        ...session,
        threads: session.threads.filter((thread) => thread.id !== chatId),
        draftByChat,
    };
}
